import GuidedFormIndicator from './GuidedFormIndicator';

export default GuidedFormIndicator;
